<label class="uc-label-input">{{ label }}: &nbsp;
  <span style="font-weight: 600;">{{value}}</span>
</label>
